import { render, staticRenderFns } from "./ItemMenuDetail.vue?vue&type=template&id=64f29030&"
import script from "./ItemMenuDetail.vue?vue&type=script&lang=js&"
export * from "./ItemMenuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports